var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBtnMenuLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 7,
    fill: "#E8E7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7728 6.97652C14.0071 7.21083 14.0071 7.59073 13.7728 7.82505L10.447 11.1508L13.7728 14.4765C14.0071 14.7108 14.0071 15.0907 13.7728 15.325C13.5384 15.5594 13.1585 15.5594 12.9242 15.325L8.74996 11.1508L12.9242 6.97652C13.1585 6.7422 13.5384 6.7422 13.7728 6.97652Z",
    fill: "#6B6888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBtnMenuLeft);
export default __webpack_public_path__ + "static/media/ic_btn_menu_left.13d8dc7cfb2d196e1acd9050ef58fa98.svg";
export { ForwardRef as ReactComponent };